<template>
  <div class="bg-dim flex-col">
    <div>
      <div class="productCards-wrap">
        <strong>원하는 디자인을 선택해주세요.</strong>
        <div v-for="(cate, i) in imageCategory.filter((c) => c.cards.length !== 0)" :key="i" class="card-box">
          <span style="font-weight:bold">{{cate.categoryName}}</span>
          <div v-for="item in cate.cards" :key="item.id"
               @click="setImageNo($event,item.imageNo)"
          >
            <div :style="{ backgroundImage:'url('+item.cardImg+')'}" class="imageBox" ></div>
          </div>
        </div>
        <div class="button-wrap fixed">
          <button class="button-bg-gray" @click="modalClose(false)">취소</button>
          <button @click="sendImageNo" class="button-bg-yellow" >선택완료</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
  name: 'ProductCards',
  components: {BottomButton},
  props: ['cardList','imageCategory'],
  data() {
    return  {
      imageNo: '',
    }
  },
  created() {
    // imageCategory를 순회하며 categoryNo에 맞는 card 정보를 imageCategory에 입력
    this.imageCategory.forEach(cate=> {
      let arr = []
      this.cardList.forEach(card=>{
        if(card.categoryNo === cate.categoryNo){
          arr.push(card)
        }
      })
      cate['cards'] = [...arr];
    })

  },
  methods : {
    /**
     * 카드 이미지 선택 모달을 닫는 함수
     * @param {Boolean} flag
     */
    modalClose(flag) {
      if(!flag){
        this.$emit('useCardImageModal', false)
      }
    },
    /**
     * 이미지 선택시 imageNo에 바인딩
     * @param {Object} event 해당 태그의 이벤트
     * @param {String} imageNo 이미지번호
     */
    setImageNo(event,imageNo){
      const divs = document.querySelectorAll('.imageBox');
      // buttons를 순회하며 selected-cash-button 클래스가 있는지 체크 후 있으면 제거
      divs.forEach(div => {
        if( div.classList.contains('selected-card-button')){
          div.classList.remove('selected-card-button')
        }
      });
      // 이벤트가 발생한 태그에 selected-card-button 클래스 부여
      event.target.classList.add('selected-card-button');
      this.imageNo = imageNo;
    },

    /**
     * 선택완료 버튼 클릭시 선택한 imageNo를 부모 컴포넌트로 보냄
     */
    sendImageNo(){
      this.$emit('getImageNo', this.imageNo);
      this.modalClose(false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/global.scss';
@import '@/assets/styles/common/productCards.scss';

.imageBox
{
  background-repeat: no-repeat;
  background-position:center;
  background-size: cover;
}
.selected-card-button{
  border: 5px solid;
}
</style>